 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"sf-payment-cancel":"sf-payment-cancel","sf-cart~sf-category-page~sf-checkout~sf-create-account~sf-forgot-password~sf-our-shop~sf-product":"sf-cart~sf-category-page~sf-checkout~sf-create-account~sf-forgot-password~sf-our-shop~sf-product","sf-our-shop":"sf-our-shop","sf-checkout":"sf-checkout","sf-create-account":"sf-create-account","sf-branches":"sf-branches","sf-page-not-found":"sf-page-not-found","sf-home":"sf-home","sf-wishlist":"sf-wishlist","sf-cart":"sf-cart","sf-category-page":"sf-category-page","sf-product":"sf-product","sf-payment-success":"sf-payment-success","sf-forgot-password":"sf-forgot-password","sf-cms-page":"sf-cms-page","sf-login":"sf-login"}[chunkId]||chunkId) + "." + {"chunk-3f2050b1":"a0d6aeb1","sf-payment-cancel":"738a4a88","chunk-75c9c6fd":"5679eb24","chunk-814bb494":"0854168b","sf-cart~sf-category-page~sf-checkout~sf-create-account~sf-forgot-password~sf-our-shop~sf-product":"cf5cac0d","chunk-25bb8ea7":"7cb85266","chunk-18f44e16":"3d1c3f4f","sf-our-shop":"40a2e790","sf-checkout":"88671884","sf-create-account":"9daff39d","chunk-d71aff3a":"65273de6","chunk-0a136f22":"8f2f69f7","chunk-41fe43ba":"9e3938eb","chunk-4dfd7e42":"8ebbf995","sf-branches":"8965e044","sf-page-not-found":"c17d96e3","sf-home":"c3781123","chunk-4cf64dad":"7790d14f","chunk-77df3562":"3918e4c7","sf-wishlist":"cba2ead4","sf-cart":"8d36059c","sf-category-page":"8a42fd04","sf-product":"1c0fdc7b","sf-payment-success":"a1e0b3cf","sf-forgot-password":"88dcc59b","sf-cms-page":"8b62a08c","sf-login":"dc05540f","chunk-2d0a30fc":"7697b710","chunk-2d0ced71":"be2df0c6","chunk-2d0ae5a4":"0b2fc454","chunk-2d0dd83c":"71f0fbf0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-3f2050b1":1,"sf-payment-cancel":1,"chunk-75c9c6fd":1,"sf-cart~sf-category-page~sf-checkout~sf-create-account~sf-forgot-password~sf-our-shop~sf-product":1,"chunk-25bb8ea7":1,"chunk-18f44e16":1,"sf-our-shop":1,"sf-create-account":1,"chunk-0a136f22":1,"chunk-41fe43ba":1,"sf-page-not-found":1,"sf-home":1,"chunk-4cf64dad":1,"chunk-77df3562":1,"sf-cart":1,"sf-category-page":1,"sf-product":1,"sf-payment-success":1,"sf-forgot-password":1,"sf-cms-page":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"sf-payment-cancel":"sf-payment-cancel","sf-cart~sf-category-page~sf-checkout~sf-create-account~sf-forgot-password~sf-our-shop~sf-product":"sf-cart~sf-category-page~sf-checkout~sf-create-account~sf-forgot-password~sf-our-shop~sf-product","sf-our-shop":"sf-our-shop","sf-checkout":"sf-checkout","sf-create-account":"sf-create-account","sf-branches":"sf-branches","sf-page-not-found":"sf-page-not-found","sf-home":"sf-home","sf-wishlist":"sf-wishlist","sf-cart":"sf-cart","sf-category-page":"sf-category-page","sf-product":"sf-product","sf-payment-success":"sf-payment-success","sf-forgot-password":"sf-forgot-password","sf-cms-page":"sf-cms-page","sf-login":"sf-login"}[chunkId]||chunkId) + "." + {"chunk-3f2050b1":"38882308","sf-payment-cancel":"36a9fcb0","chunk-75c9c6fd":"533617b2","chunk-814bb494":"31d6cfe0","sf-cart~sf-category-page~sf-checkout~sf-create-account~sf-forgot-password~sf-our-shop~sf-product":"8dafb5f0","chunk-25bb8ea7":"febab3a9","chunk-18f44e16":"38882308","sf-our-shop":"c4f068cf","sf-checkout":"31d6cfe0","sf-create-account":"c1e952d8","chunk-d71aff3a":"31d6cfe0","chunk-0a136f22":"ad34a17c","chunk-41fe43ba":"3c605659","chunk-4dfd7e42":"31d6cfe0","sf-branches":"31d6cfe0","sf-page-not-found":"9610a26e","sf-home":"c03d739a","chunk-4cf64dad":"c7f7d872","chunk-77df3562":"058da3df","sf-wishlist":"31d6cfe0","sf-cart":"e5b0d66a","sf-category-page":"6aae32aa","sf-product":"3cdd7c02","sf-payment-success":"9610a26e","sf-forgot-password":"05781ef5","sf-cms-page":"992fb79c","sf-login":"31d6cfe0","chunk-2d0a30fc":"31d6cfe0","chunk-2d0ced71":"31d6cfe0","chunk-2d0ae5a4":"31d6cfe0","chunk-2d0dd83c":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
